module.exports = __webpack_public_path__ + "img/城市给排水_-1.8db31459.png";